<template>
<main class="content">
	<div class="row u-wa">
		<h1>
              Screensavers
          </h1>
	</div>
	<div class="topBar u-wa u-fright">
		<div class="topBar--item_right">
			<router-link to="/screensavers/add" class="btn btn_blue">
				Add new screensaver
			</router-link>
		</div>
	</div>
	<div class="table">
		<div class="table--row table--row_header">

			<div class="table--col" style="max-width:141px">
				<div class="table--col-title">
					Video
				</div>
			</div>
			<div class="table--col" v-bind:class="getSortClasses('videoDetails.title')" @click="sort('videoDetails.title')" style="max-width:190px">
				<div class="table--col-title">
					Title
					<div class="table--col-arrows">
						<svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
						<svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
					</div>
				</div>
			</div>
			<div class="table--col" v-bind:class="getSortClasses('videoDetails.link')" @click="sort('videoDetails.link')" style="max-width:673px">
				<div class="table--col-title">
					Link
					<div class="table--col-arrows">
						<svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
						<svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
					</div>
				</div>
			</div>
			<div class="table--col" style="max-width:96px">
			</div>
		</div>
		<div class="table--row" v-for="screensaver in screensavers">
			<div class="table--col" style="max-width:141px">
				<a class="table--video" :href="screensaver.videoDetails.link" target="_blank" v-bind:style="{ 'background-image': 'url(' + screensaver.videoDetails.thumbnailUrl + ')' }">
                  </a>
			</div>
			<div class="table--col" style="max-width:190px">
				<span class="status">{{screensaver.status}}</span>
				<strong>
                      {{screensaver.videoDetails.title}}
                  </strong>
			</div>
			<div class="table--col" style="max-width:673px">
				<strong>
                      {{screensaver.videoDetails.link}}
                  </strong>
			</div>
			<div class="table--col" style="max-width:96px">
				<router-link :to="{ name: 'EditScreenSavers', params: { id: screensaver.id }}" class="btn btn btn_blueLight">
					Edit
				</router-link>
			</div>
		</div>

	</div>
	<a class="btn btn_green u-fleft" @click="fetchResource()" v-if="nextPage">
          Load more
      </a>
	<loading :visible.sync="loadingVisible"></loading>
</main>
</template>
<script>
import Message from '../Message.vue'
import * as ListResource from '../../mixins/listResource.mixin';
import Loading from '../Loading.vue'

export default {
	name: 'ScreenSavers',
	components: {
		Message,
		Loading
	},
	mixins: [ListResource],
	data() {
		return {
			model: 'screensavers',
			resource: 'screensavers',
			screensavers: [],
			sortOrder: 'asc',
			sortAttribute: 'videoDetails.title'
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ScreenSavers.vue?3c4e9dbe